import store from '@/store/store'

export const checkLoginToken = (to, from, next) => {
  if (!to.params.token) {
    const user = store.getters.getUser

    if (user.id) {
      return next({ name: 'home' })
    }

    return next()
  }

  this.axios.get(`/public/course-invite/check-token/${to.params.token}`).then(response => {
    if (response.data.success && response.data.check) {
      return next()
    }

    return next({ name: 'login-enter' })
  }).catch(console.error)
}
